type DeletableSample = {
  sha1?: string;
  date_submission_time?: string | null;
  string_sample_processing_status?: string | null;
  string_submissions_user?: Array<string> | null;
};

/** Shared by the menu item and its confirmation, so neither offers a delete the request will not carry. */
export const deletableSamples = <T extends DeletableSample>(
  selected: Array<T>,
  userName: string,
  isSuperuser: boolean
): Array<T> =>
  selected.filter(
    sample =>
      !!sample &&
      sample.string_sample_processing_status !== "PROCESSING" &&
      !!sample.date_submission_time &&
      (sample.string_submissions_user?.includes(userName) || isSuperuser)
  );

export default deletableSamples;
